import React from "react";

const DropdownArrowDouble = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00011 10.175L9.90011 6.30002C10.0834 6.11669 10.3126 6.02086 10.5876 6.01252C10.8626 6.00419 11.1001 6.10002 11.3001 6.30002C11.4834 6.48336 11.5751 6.71669 11.5751 7.00002C11.5751 7.28336 11.4834 7.51669 11.3001 7.70002L6.70011 12.3C6.60011 12.4 6.49178 12.4709 6.37511 12.5125C6.25844 12.5542 6.13344 12.575 6.00011 12.575C5.86678 12.575 5.74178 12.5542 5.62511 12.5125C5.50844 12.4709 5.40011 12.4 5.30011 12.3L0.700109 7.70002C0.516776 7.51669 0.420943 7.28752 0.412609 7.01252C0.404276 6.73752 0.500109 6.50002 0.700109 6.30002C0.883443 6.11669 1.11678 6.02502 1.40011 6.02502C1.68344 6.02502 1.91678 6.11669 2.10011 6.30002L6.00011 10.175ZM6.00011 4.17502L9.90011 0.300024C10.0834 0.116691 10.3126 0.0208573 10.5876 0.0125239C10.8626 0.00419059 11.1001 0.100024 11.3001 0.300024C11.4834 0.483357 11.5751 0.716691 11.5751 1.00002C11.5751 1.28336 11.4834 1.51669 11.3001 1.70002L6.70011 6.30002C6.60011 6.40002 6.49178 6.47086 6.37511 6.51252C6.25844 6.55419 6.13344 6.57502 6.00011 6.57502C5.86678 6.57502 5.74178 6.55419 5.62511 6.51252C5.50844 6.47086 5.40011 6.40002 5.30011 6.30002L0.700109 1.70002C0.516776 1.51669 0.420943 1.28752 0.412609 1.01252C0.404276 0.737524 0.500109 0.500024 0.700109 0.300024C0.883443 0.116691 1.11678 0.0250239 1.40011 0.0250239C1.68344 0.0250239 1.91678 0.116691 2.10011 0.300024L6.00011 4.17502Z"
        fill="#03579E"
      />
    </svg>
  );
};

export default DropdownArrowDouble;
